import React from "react";

import { Card, Row, Col } from "antd";
import { PaperPlus } from "react-iconly";

export default function OrdersFeatureCard(totalInvoice) {
  return (
    <Card className="hp-border-color-black-40">
      <Row>
        <Col className="hp-statistic-icon-bg hp-mr-16 hp-mb-xs-16 hp-bg-color-secondary-4 hp-bg-color-dark-secondary">
          <PaperPlus className="hp-text-color-secondary-1 remix-icon" />
        </Col>

        <Col className="hp-mt-8">
          <h3 className="hp-mb-4">
            {totalInvoice?.totalInvoice}
          </h3>

          <p className="hp-p1-body hp-mb-0 hp-text-color-black-80 hp-text-color-dark-30">
           Total Invoices
          </p>
        </Col>
      </Row>
    </Card>
  );
}